import { detectCountryCode } from "@/lib/countryDetection";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

/** ISO2 AR from worker config or client geo fallback. */
export function isArgentinaVisitor(): boolean {
  if (typeof window === "undefined") return false;
  const fromWorker = (getServerTemplateConfig()?.country ?? "").toUpperCase();
  if (/^[A-Z]{2}$/.test(fromWorker) && fromWorker !== "UNKNOWN") {
    return fromWorker === "AR";
  }
  return (detectCountryCode() ?? "").toUpperCase() === "AR";
}

/**
 * Country SEO landings append `landing` + `checkout=vip` for the intl Stripe
 * fullscreen funnel — not the admin-configured AR BaseTemplate experience.
 */
export function hasIntlSeoFunnelQuery(search: string): boolean {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  const landing = params.get("landing")?.trim();
  if (landing) return true;
  return params.get("checkout") === "vip";
}

export function stripIntlSeoFunnelQuery(search: string): string {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  params.delete("checkout");
  params.delete("landing");
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function isMembershipFunnelPath(pathname: string): boolean {
  return (
    pathname === "/ser-miembro" ||
    pathname.startsWith("/ser-miembro/") ||
    pathname === "/membership" ||
    pathname.startsWith("/membership/")
  );
}

/**
 * AR está prohibido en TODO el funnel de membership (/ser-miembro,
 * /membership) — sin requerir query intl SEO. Paridad con el worker
 * (resolveMembershipLandingRedirect: AR en membership path → "/").
 * QA desde Argentina: el geo-sim del admin (?country=) cambia el país
 * que resuelve el worker, así que isArgentinaVisitor() ya lo respeta;
 * `skip` cubre ?_force_variant / previews embebidos.
 */
export function shouldRedirectArMembershipToHome(options: {
  pathname: string;
  search: string;
  /** Admin preview / embedded preview — skip redirect. */
  skip?: boolean;
}): boolean {
  if (options.skip) return false;
  if (!isArgentinaVisitor()) return false;
  return isMembershipFunnelPath(options.pathname);
}

export function shouldRedirectArIntlSeoFunnelToHome(options: {
  pathname: string;
  search: string;
  /** Admin preview / embedded preview — skip redirect. */
  skip?: boolean;
}): boolean {
  if (options.skip) return false;
  if (!isArgentinaVisitor()) return false;
  if (!isMembershipFunnelPath(options.pathname)) return false;
  return hasIntlSeoFunnelQuery(options.search);
}